<div class="app-shell">
  @if (impersonation(); as preview) {
    <section class="preview-banner">
      <div class="preview-banner__copy">
        <span class="preview-banner__eyebrow">{{ 'impersonation.banner.eyebrow' | translate }}</span>
        <strong>{{ 'impersonation.banner.title' | translate:{ winery: auth.user()?.companyName || 'Winery' } }}</strong>
        <span class="preview-banner__text">
          {{
            'impersonation.banner.body'
              | translate:{ adminEmail: preview.adminEmail || 'admin' }
          }}
        </span>
      </div>
      <button type="button" class="ghost-button preview-banner__action" (click)="stopPreview()" [disabled]="loggingOut()">
        {{ loggingOut() ? ('impersonation.actions.stopping' | translate) : ('impersonation.actions.stop' | translate) }}
      </button>
    </section>
  }

  @if (showAppHeader()) {
    <header class="app-header">
      <a class="brand" [routerLink]="['/', language.currentLanguage, 'welcome']" appTrackClick="nav_brand">
        <div class="brand-logo">
          <img
            src="assets/favicon-64.png"
            [attr.alt]="'nav.brandLogoAlt' | translate"
            width="48"
            height="48"
            decoding="async"
          />
        </div>
        <div>
          <p class="eyebrow">{{ 'nav.partnerPortal' | translate }}</p>
          <span class="brand-name">Flourish</span>
        </div>
      </a>

      <nav class="nav-links">
        @if (auth.user(); as user) {
          <a [routerLink]="['/', language.currentLanguage, 'account']" routerLinkActive="active-link" appTrackClick="nav_account">
            {{ 'nav.account' | translate }}
          </a>
          <a [routerLink]="['/', language.currentLanguage, 'story']" routerLinkActive="active-link" appTrackClick="nav_story">
            {{ 'nav.story' | translate }}
          </a>
          @if (featureFlags.flags().showWineryWines) {
            <a [routerLink]="['/', language.currentLanguage, 'wines']" routerLinkActive="active-link" appTrackClick="nav_wines">
              {{ 'nav.wines' | translate }}
            </a>
          }
          @if (featureFlags.flags().showExperiences) {
            <a
              [routerLink]="['/', language.currentLanguage, 'experiences']"
              routerLinkActive="active-link"
              appTrackClick="nav_experiences"
            >
              {{ 'nav.experiences' | translate }}
            </a>
          }
        } @else {
          <a [routerLink]="['/', language.currentLanguage, 'login']" routerLinkActive="active-link" appTrackClick="nav_login">
            {{ 'nav.login' | translate }}
          </a>
          <a [routerLink]="['/', language.currentLanguage, 'register']" class="btn-pill" appTrackClick="nav_register">
            {{ 'nav.createAccount' | translate }}
          </a>
        }
        <a
          [attr.href]="userPortalMapUrl"
          target="_blank"
          rel="noopener noreferrer"
          appTrackClick="nav_user_portal"
          [class.ghost-button]="auth.user()"
        >
          {{ 'nav.userPortal' | translate }}
        </a>
        @if (auth.user()) {
          <button
            type="button"
            class="ghost-button"
            (click)="logout()"
            [disabled]="loggingOut()"
            appTrackClick="nav_logout"
          >
            {{
              auth.isImpersonating()
                ? (loggingOut() ? ('impersonation.actions.stopping' | translate) : ('impersonation.actions.stop' | translate))
                : (loggingOut() ? ('nav.loggingOut' | translate) : ('nav.logout' | translate))
            }}
          </button>
          <app-language-menu class="language-switcher"></app-language-menu>
        } @else {
          <app-language-menu class="language-switcher"></app-language-menu>
        }
      </nav>
    </header>
  }

  <main class="app-content">
    <router-outlet />
  </main>
</div>
<app-toast-container />
